import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRouter from './routes/AppRouter';
import { environmentService } from './services/config/environmentService';
import LoadingSpinner from './components/common/LoadingSpinner';
import './styles/globals.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { EmployeeRole, LoginResponse } from './models/types';
import Cookies from 'js-cookie';
import { useAuthStore } from './store/authStore';
import { userService } from './services/api/userService';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    }
  }
});

const App: React.FC = () => {
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const [configError, setConfigError] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      try {
        await environmentService.loadConfig();
      } catch (error) {
        setConfigError('Failed to load application configuration');
      } finally {
        setIsConfigLoaded(true);
      }

      if (!getToken()) {
        await autoLogin();
      }
    };

    init();
  }, []);

  const setUser = useAuthStore(state => state.setUser);
  const setToken = useAuthStore(state => state.setToken);
  const setSelectedRole = useAuthStore(state => state.setSelectedRole);

  // useEffect(() => {
  // }, []); setUser, setToken, setSelectedRole

  const autoLogin = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const sessionParam = params.get('session');
      const userKey = sessionParam || Cookies.get('UserSession');

      if (userKey) {
        const response: LoginResponse = await userService.autoLogin(userKey);
        if (response.success && response.data) {
          const userRoles = response.data.employeeData?.role as EmployeeRole || [];
          const userData = JSON.stringify(response.data.employeeData || []);
          sessionStorage.setItem('authToken', response.data.token);
          sessionStorage.setItem('LoggedInUser', userData);
          sessionStorage.setItem('selectedRole', response.data.employeeData?.role
            ? response.data.employeeData.role[0] : '');

          setUser(response.data.employeeData);
          setToken(response.data.token);
          if (userRoles[0]) {
            setSelectedRole(userRoles[0] as EmployeeRole);
          }

          if (sessionParam) {
            window.history.replaceState({}, '', window.location.pathname);
          }
        } else {
          throw new Error(response.message || 'Login failed');
        }
      }
    } catch(error) {
      console.error('Auto login failed:', error);
    }
  };

 const getToken=()=>{
    const token = sessionStorage.getItem('authToken');
    return token ? true : false;
 }


  if (!isConfigLoaded) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(255,255,255,0.85)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <LoadingSpinner size="large" text="Loading..." />
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        {configError && (
          <div className="alert alert-warning alert-dismissible fade show" role="alert">
            <strong>Configuration Warning:</strong> {configError}
            <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
          </div>
        )}
        <AppRouter />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </QueryClientProvider>
  );
};

export default App; 